import Channel from '@@types/Channel';
import { CHANNEL_ID } from '@@types/common';
import { ChannelPreference } from '@@types/Preference';

import { NOTIFICATION } from '~/constants';
import { PreferenceCategory } from '~/constants/member';
import { isReadSeqNotMatchSeq } from '~/services/channelService';
import { channelsStore } from '~/stores/ChannelsStore';
import { threadChannelStore } from '~/stores/ThreadChannelStore';
import { getPreferenceValueByCategory, isNotificationOn } from '~/utils/settingUtil';

class ChannelManager {
  public getById = (channelId: CHANNEL_ID) => {
    return channelsStore.getById(channelId) ?? threadChannelStore.getById(channelId);
  };

  public getChannelReadSeq = (channelId: string): number | null => {
    const channel = this.getById(channelId);
    return channel && isReadSeqNotMatchSeq(channel) ? channel.readSeq : null;
  };

  public updateChannel = <T extends Channel>(channel: Partial<T>) => {
    return channelsStore.getById(channel.channelId)
      ? channelsStore.updateChannel(channel)
      : threadChannelStore.updateChannel(channel);
  };

  public updatePreferences = (params: { channelId: string; preferences: ChannelPreference[] }) => {
    return channelsStore.getById(params.channelId)
      ? channelsStore.updatePreferences(params)
      : threadChannelStore.updatePreferences(params);
  };

  public getMainChannelId = (channelId: CHANNEL_ID) => {
    return threadChannelStore.getParentChannelId(channelId) ?? channelId;
  };

  public getMainChannel = (channelId: CHANNEL_ID) => {
    return this.getById(this.getMainChannelId(channelId));
  };

  public canNotification = (channel: Channel) => {
    return this.isNotificationOn(channel) && this.isChannelMember(channel.channelId);
  };

  private isNotificationOn = (channel: Channel) => {
    const mainChannel = this.getMainChannel(channel.channelId);
    const notificationPreference = getPreferenceValueByCategory(
      PreferenceCategory.NOTIFICATION,
      mainChannel?.preferences ?? []
    ) as NOTIFICATION;
    return isNotificationOn(notificationPreference);
  };

  private isChannelMember = (channelId: CHANNEL_ID) => {
    return channelsStore.getById(channelId) ? true : threadChannelStore.isFollow(channelId);
  };
}

export default ChannelManager;

export const channelManager = new ChannelManager();
